/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_SubtitleInputs */

const en_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help us improve -- why are you cancelling?`)
};

const de_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilf uns, besser zu werden -- warum kuendigst du?`)
};

const fr_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aide-nous a nous ameliorer -- pourquoi annules-tu ?`)
};

const es_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayudanos a mejorar -- por que cancelas?`)
};

const it_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aiutaci a migliorare -- perche annulli?`)
};

const nl_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help ons verbeteren -- waarom annuleer je?`)
};

const pl_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomoz nam sie poprawic -- dlaczego anulujesz?`)
};

const fi_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auta meita parantamaan -- miksi peruutat?`)
};

const da_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjælp os med at forbedre — hvorfor annullerer du?`)
};

const sv_cancel_subtitle = /** @type {(inputs: Cancel_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjälp oss förbättras -- varför avbryter du?`)
};

/**
* | output |
* | --- |
* | "Help us improve -- why are you cancelling?" |
*
* @param {Cancel_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_subtitle = /** @type {((inputs?: Cancel_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_subtitle(inputs)
	if (locale === "fr") return fr_cancel_subtitle(inputs)
	if (locale === "es") return es_cancel_subtitle(inputs)
	if (locale === "it") return it_cancel_subtitle(inputs)
	if (locale === "nl") return nl_cancel_subtitle(inputs)
	if (locale === "pl") return pl_cancel_subtitle(inputs)
	if (locale === "fi") return fi_cancel_subtitle(inputs)
	if (locale === "da") return da_cancel_subtitle(inputs)
	if (locale === "sv") return sv_cancel_subtitle(inputs)
	return en_cancel_subtitle(inputs)
});